import React from 'react';
import { Link } from 'react-router-dom';
import { Table, ArrowRight, Map, FileText, Hash, Home, Key, BookOpen } from 'lucide-react'; // Added BookOpen icon

const RawDataMenu = () => {
  return (
    <div style={{ maxWidth: '800px', paddingBottom: '40px' }}>
      
      {/* ... Header ... */}
      <div style={{ marginBottom: '30px' }}>
        <Link to="/real-estate" style={{ color: '#64748b', textDecoration: 'none', fontSize: '14px' }}>← Back to Hub</Link>
        <h1 style={{ marginTop: '10px', color: '#1e293b' }}>Raw Data Management</h1>
      </div>

      {/* --- 1. SALES --- */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={sectionHeaderStyle}>Kupoprodajni posli (Sales)</h2>
        <div style={cardContainerStyle}>
           {/* ... existing sales items ... */}
           <MenuItem to="/real-estate/raw/sales/posli" icon={<FileText size={20} color="#2563eb" />} title="Transactions (Posli)" desc="Sales contracts, prices." />
           <MenuItem to="/real-estate/raw/sales/delistavb" icon={<Table size={20} color="#059669" />} title="Parts of Buildings" desc="Apartments, sizes." />
           <MenuItem to="/real-estate/raw/sales/zemljisca" icon={<Map size={20} color="#d97706" />} title="Land (Zemljišča)" desc="Plots, agriculture." />
           <MenuItem to="/real-estate/raw/sales/sifranti" icon={<Hash size={20} color="#64748b" />} title="Codes (Šifranti)" desc="Lookup tables." />
        </div>
      </div>

      {/* --- 2. RENTALS --- */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={sectionHeaderStyle}>Najemni posli (Rentals)</h2>
        <div style={cardContainerStyle}>
           {/* ... existing rental items ... */}
           <MenuItem to="/real-estate/raw/rentals/posli" icon={<Key size={20} color="#7c3aed" />} title="Rental Transactions" desc="Registered agreements." />
           <MenuItem to="/real-estate/raw/rentals/delistavb" icon={<Home size={20} color="#db2777" />} title="Rental Units" desc="Rented properties." />
           <MenuItem to="/real-estate/raw/rentals/sifranti" icon={<Hash size={20} color="#64748b" />} title="Codes" desc="Rental lookups." />
        </div>
      </div>

      {/* --- 3. KN DATA --- */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={sectionHeaderStyle}>KN (Kataster Nepremičnin)</h2>
        <div style={cardContainerStyle}>
          <MenuItem to="/real-estate/raw/kn/delistavb" icon={<Table size={20} color="#0891b2" />} title="KN Deli stavb" desc="Parts of buildings from KN." />
          <MenuItem to="/real-estate/raw/kn/imetniki" icon={<Home size={20} color="#0891b2" />} title="KN Imetniki lastnistva" desc="Owners of real estate." />
          <MenuItem to="/real-estate/raw/kn/osebe" icon={<FileText size={20} color="#0891b2" />} title="KN Osebe" desc="Persons and entities involved." />
          <MenuItem to="/real-estate/raw/kn/naslovi" icon={<Map size={20} color="#0891b2" />} title="KN Naslovi HS" desc="House number addresses." />
          <MenuItem to="/real-estate/raw/kn/stavbe" icon={<Home size={20} color="#0ea5e9" />} title="KN Stavbe" desc="Building points from shapefile." />
        </div>
      </div>

      {/* --- 4. EV DATA --- */}
      <div style={{ marginBottom: '40px' }}>
        <h2 style={sectionHeaderStyle}>EV (Evidenca Vrednotenja)</h2>
        <div style={cardContainerStyle}>
          <MenuItem to="/real-estate/raw/ev/vrednotenja" icon={<Table size={20} color="#0ea5e9" />} title="EV Vrednotenja" desc="Valuation records and attributes." />
        </div>
      </div>

      {/* --- 5. LEGAL & OWNERSHIP --- */}
      <div>
        <h2 style={sectionHeaderStyle}>Zemljiška Knjiga (Legal)</h2>
        <div style={cardContainerStyle}>
          
          {/* NEW CARD */}
          <MenuItem 
            to="/real-estate/raw/zk" 
            icon={<BookOpen size={20} color="#b45309" />} 
            title="Land Registry Extracts (ZK)"
            desc="Parsed PDF data: Owners, Parcels, and Legal status."
          />

        </div>
      </div>

    </div>
  );
};

// ... Styles and MenuItem component remain the same ...
const MenuItem = ({ to, icon, title, desc }) => (
  <Link to={to} style={itemStyle}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
      <div style={iconBoxStyle}>{icon}</div>
      <div>
        <div style={{ fontWeight: '600', color: '#1e293b' }}>{title}</div>
        <div style={{ fontSize: '13px', color: '#64748b' }}>{desc}</div>
      </div>
    </div>
    <ArrowRight size={18} color="#cbd5e1" />
  </Link>
);

const sectionHeaderStyle = { fontSize: '18px', fontWeight: '700', color: '#334155', marginBottom: '15px', marginLeft: '5px' };
const cardContainerStyle = { backgroundColor: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e2e8f0' };
const itemStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px', borderBottom: '1px solid #f1f5f9', textDecoration: 'none', backgroundColor: 'white', cursor: 'pointer' };
const iconBoxStyle = { width: '36px', height: '36px', borderRadius: '6px', backgroundColor: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e2e8f0' };

export default RawDataMenu;